// extracted by mini-css-extract-plugin
module.exports = {"largeMap":"styles_largeMap__xusoc","mobileMap":"styles_mobileMap__236tV"};